import * as React from 'react'

interface IconProps extends React.SVGProps<SVGSVGElement> {}

const LMEmail: React.FC<IconProps> = (props) => (
  <svg 
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg" 
    width={16}
    height={16}
    viewBox="0 0 1200 1200" 
    xmlSpace="preserve"
    {...props}
  >
    <path d="M0 972.138V556.629c2.192-43.973 37.788-75.724 76.898-76.252h186.106c53.196-40.854 90.897-97.554 142.165-138.611q27.141-21.648 42.003-48.142c32.214-63.281 12.695-136.954 58.481-187.399 92.008-39.482 202.231 15.751 233.279 102.423 24.405 70.78 8.052 141.366-22.294 203.877 109.856-.182 219.71.708 329.563 1.292 89.434 6.678 153.202 66.892 153.797 152.504-.244 86.275-74.623 149.017-153.797 150.565h-129.24q-6.462 38.126-25.202 69.144c7.239 53.145-9.327 105.247-41.356 142.812-17.576 306.75-419.443 124.761-569.952 120.193H76.898C32.617 1046.939.528 1011.445 0 972.138m277.221 0c120.425 2.591 531.909 184.658 492.407-76.252 43.546-23.471 60.301-86.286 33.603-126.01 40.566-40.005 52.118-90.265 12.925-129.887q58.157 0 115.023-.646t115.024-.646c44.371-.933 75.122-33.487 75.606-72.374-1.014-45.976-35.914-75.137-75.606-75.606-150.385-.008-298.632-1.276-438.126-1.292 12.555-100.763 132.769-237.585 10.017-316.963-19.652-9.652-35.367-13.749-55.896-10.017q-5.17 2.585-5.816 5.17t-1.938 8.4c-13.044 79.87-25.221 159.73-87.237 212.601-68.263 52.343-108.514 134.749-186.752 168.014h-3.231z"/></svg>
)

export default LMEmail
